import DetailsSkeleton from '@/features/dashboard/bookingChanges/components/DetailsSkeleton.tsx';

/** `pendingComponent` ekranu rezerwacji — pięć zakładek i rachunek w kolumnie treści. */
const BookingDetailsSkeleton = () => <DetailsSkeleton tabCount={5} />;

export default BookingDetailsSkeleton;
